var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.itemClass,attrs:{"title":_vm.groupDesc}},[_vm._v(" "+_vm._s(_vm.groupName)+" "),(_vm.groupDesc)?_c('i',{staticClass:"bi-info-circle-fill info-icon"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }